const preferredSizeDatasetKey = 'apPreferredSize';

function setPreferredSize(value) {
  const size = String(value || '').trim();

  if (size) {
    document.documentElement.dataset[preferredSizeDatasetKey] = size;
  } else {
    delete document.documentElement.dataset[preferredSizeDatasetKey];
  }
}

function getPreferredSize() {
  const stored = document.documentElement.dataset[preferredSizeDatasetKey]?.trim();
  if (stored) return stored;

  const activeSizes = Array.from(
    document.querySelectorAll(
      '[data-ap-shoe-filter-section] [data-ap-size].is-active, [data-ap-shoe-filter-section] [data-ap-size][aria-pressed="true"]'
    )
  );
  const lastActive = activeSizes.at(-1);

  return lastActive instanceof HTMLElement ? lastActive.dataset.apSize?.trim() || null : null;
}

function isSizeOptionName(name) {
  const normalized = String(name || '').trim().toLowerCase();
  return normalized === 'storlek' || normalized === 'size';
}

function syncPreferredSizeToModal() {
  const preferredSize = getPreferredSize();
  if (!preferredSize) return;

  const modalContent = document.getElementById('quick-add-modal-content');
  if (!modalContent) return;

  const radioInputs = modalContent.querySelectorAll('input[type="radio"][data-option-name]');

  for (const input of radioInputs) {
    if (!(input instanceof HTMLInputElement)) continue;
    if (!isSizeOptionName(input.dataset.optionName)) continue;
    if (input.value.trim() !== preferredSize) continue;
    if (input.dataset.optionAvailable === 'false' || input.getAttribute('aria-disabled') === 'true') continue;

    if (!input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }

  const selects = modalContent.querySelectorAll('variant-picker select');

  for (const select of selects) {
    if (!(select instanceof HTMLSelectElement)) continue;

    const label = select.closest('.variant-option')?.querySelector('label');
    if (!isSizeOptionName(label?.textContent)) continue;

    const option = Array.from(select.options).find((item) => item.value.trim() === preferredSize);
    if (!option || option.disabled) continue;

    if (select.value !== preferredSize) {
      select.value = preferredSize;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return;
  }
}

document.addEventListener('click', (event) => {
  if (!(event.target instanceof Element)) return;

  const sizeChip = event.target.closest('[data-ap-size]');
  if (sizeChip instanceof HTMLElement) {
    requestAnimationFrame(() => {
      const isActive =
        sizeChip.classList.contains('is-active') || sizeChip.getAttribute('aria-pressed') === 'true';

      if (isActive) {
        setPreferredSize(sizeChip.dataset.apSize);
        return;
      }

      const currentPreferred = document.documentElement.dataset[preferredSizeDatasetKey];
      if (currentPreferred !== sizeChip.dataset.apSize) return;

      const filterRoot = sizeChip.closest('[data-ap-shoe-filter-section]');
      const activeSizes = filterRoot
        ? Array.from(filterRoot.querySelectorAll('[data-ap-size].is-active, [data-ap-size][aria-pressed="true"]'))
        : [];
      const fallback = activeSizes.at(-1);

      setPreferredSize(fallback instanceof HTMLElement ? fallback.dataset.apSize : '');
    });
    return;
  }

  if (event.target.closest('[data-ap-reset]')) {
    requestAnimationFrame(() => setPreferredSize(''));
  }
});

customElements.whenDefined('quick-add-component').then(() => {
  const QuickAddComponent = customElements.get('quick-add-component');
  if (!QuickAddComponent) return;

  const prototype = QuickAddComponent.prototype;
  if (prototype.__arbetsproPreferredSizePatched) return;

  const originalUpdateQuickAddModal = prototype.updateQuickAddModal;
  if (typeof originalUpdateQuickAddModal !== 'function') return;

  prototype.updateQuickAddModal = async function (...args) {
    const result = await originalUpdateQuickAddModal.apply(this, args);
    syncPreferredSizeToModal();
    return result;
  };

  Object.defineProperty(prototype, '__arbetsproPreferredSizePatched', {
    value: true,
    configurable: false,
    enumerable: false,
    writable: false,
  });
});
